<template>
  <b-card class="shipping--protection--container">
    <ul class="pl-1">
      <li class="li-info"><span>EnvíaSafe</span> te respalda ante imprevistos. Activa este servicio y obtén una cobertura de póliza por el valor total del producto en caso de extravío o daños durante el transporte.</li>
    </ul>
    <section>
      <div class="section--title--container">
        <h1 class="title-section">Limite del seguro Envíame</h1>
        <b-icon :style="{color: `${activeStatus.colorStatus}`}" icon="circle-fill" font-scale=".86"></b-icon>
        <span>{{ activeStatus.textActive }}</span>
      </div>
      <form-render ref="formOne" :form.sync="form" :fields="field" :key="keyFormRender" formClass="form--shipping-protection"></form-render>
    </section>
    <section>
      <div class="section--title--container">
        <h1 class="title-section">Representantes de la empresa</h1>
      </div>
      <p class="description--text">
       Revisa los correos electrónicos preseleccionados. Elimina los que no estén vigentes o no correspondan, y agrega los que sean necesarios. Si no hay ninguno, debes ingresar al menos uno, ya que es obligatorio contar con un contacto. Es importante mantener esta información actualizada, ya que a estos representantes se les enviará la solicitud para la activación del servicio.
      </p>
      <form-render ref="formTwo" :form.sync="form" :fields="fieldSectionTwo" :key="keyFormRender" formClass="form--shipping-protection"></form-render>
    </section>
    <section class="shipping--section-buttons" v-if="dataShippingProtection && !dataShippingProtection.enabled">
      <b-button variant="outline-warning" @click="submitForms">Guardar y Salir</b-button>
      <b-button variant="warning" type="button" @click="submitFormsActivate">Activar</b-button>
    </section>
  </b-card>
</template>
<script>
import {
  BIcon,
  BIconCircleFill
} from 'bootstrap-vue'
/* eslint-disable vue/no-unused-components */
import Swal from 'sweetalert2'
import BaseServices from '@/store/services/index'
export default {
  props: ['companyData'],
  components: {BIcon, BIconCircleFill},
  data() {
    return {
      baseService: new BaseServices(this),
      activeStatus: {
        colorStatus: '#D1DADE',
        textActive: 'Inactivo'
      },
      keyFormRender: 0,
      form: {},
      loading: false,
      field: [],
      fieldSectionTwo: [],
      syncing: false,
      dataShippingProtection: null,
      optionAlwaysProtect: [
        { text: 'No', id: 'false' },
        { text: 'Si', id: 'true' }
      ]
    }
  },
  watch: {
    'form.always_protect': {
      handler(newVal) {
        if (newVal) {
          this.disableCurrencySelect(newVal)
        }
      },
      immediate: true,
      deep: true
    },
    optionSelected1(newVal, oldVal) {
      if (this.syncing || newVal === oldVal) return
      this.syncing = true
      this.optionSelected2 = newVal
      this.syncing = false
    },
    optionSelected2(newVal, oldVal) {
      if (this.syncing || newVal === oldVal) return
      this.syncing = true
      this.optionSelected1 = newVal
      this.syncing = false
    }
  },
  computed: {
    optionSelected1: {
      get() {
        return this.field[1]?.append?.optionSelected
      },
      set(value) {
        this.field[1].append.optionSelected = value
      }
    },
    optionSelected2: {
      get() {
        return this.field[2]?.append?.optionSelected
      },
      set(value) {
        this.field[2].append.optionSelected = value
      }
    }
  },
  mounted() {
    this.setForm()
  },
  methods: {
    activateShippingProtection() {
      const queryParams = {
        shipper_id: this.companyData?.company?.id,
        organization_id: this.companyData?.company?.dubai_organization_id,
        admin_email_activation: this.$session.get('cas_user')?.email
      }
      const params = {}
      this.baseService.callService('activateShippingProtection', queryParams, params)
        .then(response => {
          this.setForm()
          this.viewSuccessMessage({
            text: '¡El servicio fue activado con éxito!',
            html: 'En breve notificaremos a los representantes y al ejecutivo comercial que el servicio ya está activo en la plataforma.'
          })
        })
        .catch(err => {
          console.error('Error al obtener la configuración de la póliza:', err)
          this.$bvToast.toast('Error al obtener la configuración de la póliza', {
            title: 'Error',
            variant: 'danger',
            solid: true
          })
        })
        .finally(end => {
          document.getElementById('loading-bg').style.display = 'none'
        })
    },
    getDataPolicy() {
      document.getElementById('loading-bg').style.display = 'block'
      const queryParams = {
        shipper_id: this.companyData?.company?.id
      }
      const params = {}
      this.baseService.callService('getCompanyPolicyConfig', queryParams, params)
        .then(response => {
          this.dataShippingProtection = response.data[0]
          this.setValues()
          this.setStatus()
        })
        .catch(err => {
          console.error('Error al obtener la configuración de la póliza:', err)
          this.$bvToast.toast('Error al obtener la configuración de la póliza', {
            title: 'Error',
            variant: 'danger',
            solid: true
          })
        })
        .finally(end => {
          document.getElementById('loading-bg').style.display = 'none'
        })
    },
    setValues() {
      this.form = {
        always_protect: !!this.dataShippingProtection?.always_protect ? this.optionAlwaysProtect[1] : this.optionAlwaysProtect[0],
        product_not_available: this.dataShippingProtection?.product_not_available || 0,
        product_is_higher: this.dataShippingProtection?.product_is_higher || 0,
        decision_makers_emails: this.dataShippingProtection?.decision_makers_emails || []
      }
    },
    setStatus() {
      if (this.dataShippingProtection?.enabled) {
        this.activeStatus.colorStatus = '#1E8E3E'
        this.activeStatus.textActive = 'Activo'
      } else {
        this.activeStatus.colorStatus = '#D1DADE'
        this.activeStatus.textActive = 'Inactivo'
      }
      this.keyFormRender++
    },
    clearForm() {
      this.setForm()
    },
    disableCurrencySelect (value) {
      const nameDisable = ['product_not_available', 'product_is_higher']
      this.field.map(item => {
        if (nameDisable.includes(item.name) && !!value && value.id) {
          item.disabled = value.id === 'true'
        }
      })
      this.keyFormRender++
    },
    async submitForms(source = 'button') {
      try {
        const validOne = await this.$refs.formOne.onlyCheckForm()
        const validTwo = await this.$refs.formTwo.onlyCheckForm()
        if (!validOne || !validTwo) {
          throw new Error('Faltan llenar datos en formulario')
        }
        this.setCurrencySelected()
        this.sendForm(source)
      } catch (error) {
        const errorText = error.message || 'Ha ocurrido un error inesperado'
        this.$bvToast.toast(errorText, {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
      }
    },
    sendForm(source) {
      const always_protect = this.form.always_protect.id === 'true'
      const queryParams = {
        always_protect,
        shipper_id: this.companyData?.company?.id,
        product_not_available: always_protect ? 0 : this.form?.product_not_available ?? 0,
        product_is_higher: always_protect ? 0 : this.form?.product_is_higher ?? 0,
        decision_makers_emails: this.form.decision_makers_emails ?? [],
        terms_conditions: false,
        admin_email_creation: this.$session.get('cas_user')?.email,
        organization_id: this.companyData?.company?.dubai_organization_id
      }
      document.getElementById('loading-bg').style.display = 'block'
      this.baseService.callService('postCompanyPolicyConfig', queryParams, null)
        .then(response => {
          this.viewSuccessMessage()
        })
        .catch(err => {
          console.error('Error al actualizar la configuración de la póliza:', err)
          this.$bvToast.toast('Error al actualizar la configuración de la póliza', {
            title: 'Error',
            variant: 'danger',
            solid: true
          })
        })
        .finally(() => {
          if (source === 'button') this.setForm()
          document.getElementById('loading-bg').style.display = 'none'
        })
    },
    viewSuccessMessage(data) {
      Swal.fire({
        titleText: data?.text ?? '¡La solicitud para activar el servicio fue enviada con éxito!',
        html: data?.html ?? 'En breve notificaremos a los representantes y al ejecutivo comercial para su aprobación.',
        background: '#E6F0E8',
        icon: 'success',
        position: 'bottom-start',
        showConfirmButton: false,
        showCloseButton: true,
        width: '750px',
        customClass: {
          popup: 'swal2-toast swal--shipping-protection'
        },
        allowOutsideClick: false
      })
    },
    setCurrencySelected() {
      const nameVerify = ['product_not_available', 'product_is_higher']
      this.field.map(item => {
        if (nameVerify.includes(item.name) && !!this.form[item.name]) {
          this.form[`currency_${item.name}`] = item.append.optionSelected
        }
      })
    },
    setForm() {
      this.form = {}
      const currencyOptions = [
        { value: 'US', text: 'US' },
        { value: 'MX', text: 'MX' },
        { value: 'COP', text: 'COP' }
      ]
      this.field = [
        { fieldType: 'FieldRadio', name: 'always_protect', label: 'Protege siempre el valor de tu producto', align: 'h', containerClass: 'container-info label--text', options: this.optionAlwaysProtect, validation: 'required' },
        { fieldType: 'FieldInput', name:'product_not_available', label: 'Cuando el valor del pedido no esté disponible, configure siempre la cobertura de póliza en :', containerClass: 'container-info label-text', append: {text: 'Peso Chileno', options: currencyOptions, returnOption: true, optionSelected: currencyOptions[0].value}, placeholder: 'Ingrese valor', clearable: false },
        { fieldType: 'FieldInput', name:'product_is_higher', label: 'Cuando el valor del pedido sea superior al valor declarado, configure siempre la cobertura de póliza en :', containerClass: 'container-info label-text', append: {text: 'Peso Chileno', options: currencyOptions,  returnOption: true,  optionSelected: currencyOptions[0].value}, placeholder: 'Ingrese valor', clearable: false }
      ]
      this.fieldSectionTwo = [
        { fieldType: 'FieldTags', label: 'Correos electrónicos', name: 'decision_makers_emails',
          labelClass: 'mb-1',
          disabled: this.loading, containerClass: 'container-info label--text', validation: 'required',
          placeholder: 'Ingrese hasta diez correos electrónicos, separados por una coma o un enter',
          tagsOption: {
            limitTagsText: this.$t('Límite de correos electrónicos alcanzado. Para agregar uno nuevo, primero elimina alguno de los ya ingresados.'),
            duplicateTagText: this.$t('Orden de transporte duplicada'),
            invalidTagText: 'Correo inválido',
            limit: 10,
            validations: 'validateEmail'
          }
        }
      ]
      this.getDataPolicy()
      this.keyFormRender++ 
    },
    submitFormsActivate() {
      this.submitForms('activate')
        .then(() => {
          this.activateShippingProtection()
        })
        .catch(error => {
          console.error('Error al enviar el formulario:', error)
          this.$bvToast.toast('Error al enviar el formulario', {
            title: 'Error',
            variant: 'danger',
            solid: true
          })
        })
    }
  }
}
</script>
<style lang="scss">
  .shipping--protection--container {
    .li-info,
    .section--title,
    .label--text .label-form,
    .description--text {
      font-family: Montserrat;
      line-height: 100%;
      letter-spacing: 0;
    }
    .li-info {
      font-weight: 400;
      font-size: 14px;
      color: #6E6B7B;
      margin-bottom: 50px;
    }
    .li-info span {
      font-weight: 600;
    }
    .title-section {
      font-weight: 500;
      font-size: 18px;
      color: #044389;
      border-bottom : 3px solid #044389;
      width: fit-content;
      padding: 0 20px 5px;
      margin-bottom: 0;
    }
    .button--activator {
      display: flex;
      align-items: center;
      gap: 5px;
      // font-weight: 500;
      // font-size: 14px;
      color: inherit !important;
      background-color: transparent !important;
      border: none !important;
      padding: 0;
      // cursor: pointer;
    }
    .section--title--container {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 40px;
    }
    .custom-radio.custom-control {
      width: fit-content;
    }
    .label--text .label-form {
      font-weight: 400;
      font-size: 14px;
      color: #6E6B7B;
    }
    .form--shipping-protection {
      display: grid;
      gap: 40px;
      margin: 0;
      .form-group {
        width: fit-content;
      }
    }
    .shipping--section-buttons {
      display: flex;
      gap: 10px;
      justify-content: end;
    }
    .description--text {
      font-weight: 400;
      font-size: 14px;
      color: #6E6B7B;
      margin-bottom: 40px;
      line-height: 200%;
    }
  } 
  .swal--shipping-protection {
    .swal2-title,
    .swal2-html-container {
      font-family: Montserrat !important;
      font-weight: 300 !important;
      font-size: 14px !important;
      line-height: 100% !important;
      letter-spacing: 0 !important;
      color: #020202 !important;
    }
    .swal2-title {
      font-weight: 500 !important;
    }
  }
</style>